<template>
  <AppNavigation mode="topbar"/>
  <div class="home">
    <HeroSection />
    <HowItWorksSection />
    <LearningModesSection />
    <LanguagesSection />
    <TestimonialsSection />
    <PricingSection />
    <FinalCtaSection />
  </div>
  <FooterSection/>

</template>

<script>
import AppNavigation from "@/components/AppNavigation.vue";
import HeroSection from "@/components/HeroSection.vue";
import HowItWorksSection from "@/components/HowItWorksSection.vue";
import PricingSection from "@/components/PricingSection.vue";
import FooterSection from "@/components/FooterSection.vue";
import LearningModesSection from "@/components/LearningModesSection.vue";
import LanguagesSection from "@/components/LanguagesSection.vue";
import TestimonialsSection from "@/components/TestimonialsSection.vue";
import FinalCtaSection from "@/components/FinalCtaSection.vue";
import { computed } from "vue";
import { useHead } from "@unhead/vue";
import { authSetupMixin } from "@/mixins/authSetupMixin.js";
import { publicPageHead } from "@/scripts/publicHead.js";
// A plain served path, not a webpack import: public/ is copied to dist/
// verbatim, so this URL survives an edit of the image, where a bundled asset
// would carry a content hash that 404s in every crawler cache holding a card.
// The same constant feeds src/data/publicRoutes.js, so the head a crawler
// without JavaScript reads names the same file this one does.
import { SOCIAL_CARD_PATH } from "@/data/socialMeta.js";


export default {
  components: {
    HeroSection,
    HowItWorksSection,
    PricingSection,
    AppNavigation,
    FooterSection,
    LearningModesSection,
    LanguagesSection,
    TestimonialsSection,
    FinalCtaSection,
  },
  name: "HomeView",
  mixins: [authSetupMixin],
  data() {
    return {
      socialImage: SOCIAL_CARD_PATH,
    };
  },
  mounted() {
    // These were module-level const strings, which is why the literal-copy
    // scanner never saw them: it reads sinks, and a sink fed by an identifier
    // carries no literal. That blind spot is disclosed in the scanner header --
    // it is also why the landing page was the last tab still in English after
    // every other page had been translated. computed, because locale bundles
    // load lazily and a value read at mount can freeze the English fallback in.
    useHead(
      publicPageHead({
        title: computed(() => this.$t("home.metaTitle")),
        description: computed(() => this.$t("home.metaDescription")),
        path: "/",
        image: this.socialImage,
      }),
    );
  },
};
</script>

<style scoped>
body {
  overflow-x: hidden;
}

.home {
  margin-top: var(--al-topbar-height);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* No mobile margin-top override: --al-topbar-height resolves per breakpoint. */
</style>
